// Signup-flow conversion pixels: Meta, Google Floodlight, Microsoft UET and The Trade Desk.
// Tag ids/events come from the MSA Conversion Pixel Configuration Matrix (signup page);
// privacy gating + 1x1 image-pixel delivery follow the AdTech Pixel Governance Guidelines.

function getCookie(name) {
  const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
  return match ? match[2] : '';
}

// Governance section 3: any failing consent check blocks all pixel transmission.
export function isPixelTransmissionAllowed() {
  // 3.1 Global Privacy Control opt-out signal.
  if (navigator.globalPrivacyControl === true) {
    return false;
  }
  // 3.3 Advertising / personalization opt-out cookie.
  if (getCookie('3PAdsOptOut') === '1') {
    return false;
  }
  // 3.2 Cookie consent (Microsoft WCP `mscc`, injected by the universal header).
  const { mscc } = window;
  return !!(mscc && typeof mscc.hasConsent === 'function' && mscc.hasConsent());
}

// The four signup conversion pixel URLs, each a 1x1 image with a cachebuster (governance section 7).
export function getSignupConversionPixelUrls(cachebuster) {
  const cb = cachebuster || `${Date.now()}${Math.floor(Math.random() * 1e6)}`;
  return [
    // Meta (pixel 1770559986549030) — MSASignUp conversion.
    `https://www.facebook.com/tr?id=1770559986549030&ev=MSASignUp&noscript=1&rnd=${cb}`,
    // Google Floodlight (DC-8390843) — us_ms00 standard.
    `https://ad.doubleclick.net/ddm/activity/src=8390843;type=msaps0;cat=us_ms00;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=;gdpr_consent=;ord=${cb}?`,
    // Microsoft UET (ti 4000034) — MSFTAds Account Creation.
    `https://bat.bing.net/action/0?ti=4000034&Ver=2&evt=custom&ea=${encodeURIComponent('MSFTAds Account Creation')}&rn=${cb}`,
    // The Trade Desk.
    `https://insight.adsrvr.org/track/pxl/?adv=rpingfj&ct=0:hp3osef&fmt=3&cachebuster=${cb}`,
  ];
}

// Fires the four conversion pixels as 1x1 images. Never throws so signup is never broken.
export function fireSignupConversionPixels() {
  getSignupConversionPixelUrls().forEach((url) => {
    try {
      const img = new Image(1, 1);
      // Keep the signup URL (cid/aid/uid/email) out of the Referer header sent to pixel vendors.
      img.referrerPolicy = 'no-referrer';
      img.src = url;
    } catch (e) {
      // pixel failures must never break signup
    }
  });
}

// Fires the pixels only when governance consent gates allow it. Returns whether they fired.
export function reportSignupConversion() {
  if (!isPixelTransmissionAllowed()) {
    return false;
  }
  fireSignupConversionPixels();
  return true;
}
